import React, { PropTypes } from 'react';
import { AuthorizedComponent } from 'react-router-role-authorization';
import { connect } from 'react-redux';
import { browserHistory, withRouter } from 'react-router';
import Spinner from 'react-spinkit';
import _ from 'lodash';
import {
    ASSIGNMENTS__REQUESTED,
    DROPBOXES__REQUESTED,
    DROPBOX__USER__MEMBERSHIPS__REQUESTED,
    DROPBOX__USERS__REQUESTED,
    DROPBOX__USER__SUBMISSIONS__REQUESTED,
    FILE__DOWNLOAD__REQUESTED,
    ROLES__SELF__REQUESTED
} from "../constants/actionTypes";
import { INSTRUCTOR } from "../constants/roles";
import Container from "../components/bootstrap/Container";
import CardBlock from "../components/bootstrap/CardBlock";
import CardHeader from "../components/bootstrap/CardHeader";
import FileSubmission from "../components/FileSubmission";
import NavBar from "../components/NavBar";
import NavLink from "../components/NavLink";
import {spaceToUnderscore} from "../helpers/helpers";

class SubmittedPage extends AuthorizedComponent  {
    constructor(props) {
        super(props);

        this.userRoles = props.auth.roles;
        this.notAuthorizedPath = '/not-found';

        this.handleLatestRunscripts = this.handleLatestRunscripts.bind(this);
        this.hasOptionalFiles = this.hasOptionalFiles.bind(this);
        this.hasRequiredFiles = this.hasRequiredFiles.bind(this);
        this.onDownloadFile = this.onDownloadFile.bind(this);
    }

    componentDidMount() {
        const { dispatch } = this.props;

        dispatch({
            type: ROLES__SELF__REQUESTED
        });
    }

    componentDidUpdate(prevProps) {
        const { assignments, dispatch, dropboxes, memberships, params, roles_self, submissions, users } = this.props,
            dropboxId = parseInt(params.dropboxId),
            userId = parseInt(params.userId)
        ;

        if (prevProps.roles_self !== roles_self) {
            const hasInstructorRole = _.includes(
                _.flatMap(
                    roles_self,
                    dropbox_role => {
                        if (dropbox_role.dropbox.id === dropboxId) {
                            return dropbox_role.role;
                        }
                    }),
                INSTRUCTOR
            );

            if (hasInstructorRole) {
                if (_.size(assignments) < 1) {
                    dispatch({
                        type: ASSIGNMENTS__REQUESTED,
                    });
                }

                if (_.size(dropboxes) < 1) {
                    dispatch({
                        type: DROPBOXES__REQUESTED,
                    });
                }

                if (users.dropbox !== dropboxId) {
                    dispatch({
                        type: DROPBOX__USERS__REQUESTED,
                        payload: {
                            dropboxId: dropboxId,
                        },
                    });
                }

                if (memberships.dropbox !== dropboxId || memberships.user !== userId) {
                    dispatch({
                        type: DROPBOX__USER__MEMBERSHIPS__REQUESTED,
                        payload: {
                            dropboxId: dropboxId,
                            userId: userId,
                        },
                    });
                }

                if (submissions.dropbox !== dropboxId || submissions.user !== userId) {
                    dispatch({
                        type: DROPBOX__USER__SUBMISSIONS__REQUESTED,
                        payload: {
                            dropboxId: dropboxId,
                            userId: userId,
                        },
                    });
                }
            } else {
                browserHistory.push('/not-found');
            }
        }
    }

    onDownloadFile(event) {
        event.preventDefault();
        let file_id = event.target.id;
        let file_name = event.target.attributes.getNamedItem('name').value;

        this.props.dispatch({
            type: FILE__DOWNLOAD__REQUESTED,
            payload: {
                file_id : parseInt(file_id),
                file_name : file_name
            }
        });
    }

    hasRequiredFiles(assignment) {
        let { assignment_filenames } = assignment;

        return _.filter(assignment_filenames, ['optional', false]).length > 0;
    }

    hasOptionalFiles(assignment) {
        let { assignment_filenames } = assignment;

        return _.filter(assignment_filenames, ['optional', true]).length > 0;
    }

    handleLatestRunscripts(event) {
        event.preventDefault();

        const { params } = this.props,
            { assignmentId, dropboxId, userId } = params
        ;

        browserHistory.push(`/dropboxes/${dropboxId}/users/${userId}/assignments/${assignmentId}/runscripts`);
    }

    render() {
        const isLoading = this.props.request.sendingRequest;
        if (isLoading) {
            return (
                <Spinner
                    spinnerName="wandering-cubes"
                    className="spinner"
                    noFadeIn
                />
            );
        }

        const { assignments, dropboxes, memberships, params, submissions, users } = this.props,
            assignment = assignments[params.assignmentId],
            dropbox = dropboxes[params.dropboxId],
            submission = _.first(
                _.filter(
                    submissions,
                    submission => {
                        if (submission === submissions.dropbox || submission === submissions.user) {
                            return false;
                        }

                        const confirmed = _.size(
                            _.filter(
                                memberships,
                                membership => {
                                    return membership.confirmed && membership.submission.id === submission.id;
                                }
                            )
                        ) > 0;

                        return confirmed && submission.assignment.id === assignment.id && submission.updated;
                    }
                )
            ),
            user = users[params.userId]
        ;

        if (assignment && dropbox && submission && user) {
            return (
                <div className="col-md-12">
                    <div className={"action-links"}>
                        <NavBar
                            className="navbar navbar-toggleable-md navbar-light bg-faded fixed-top navbar-sub"
                            display
                        >
                            <NavLink
                                to={`/dropbox/${dropbox.id}/users/${user.id}`}
                                className="btn btn-outline-primary btn-md"
                                side="left"
                                display
                                key="user"
                            >
                                Exit To User: {user.username} <i className={"fa fa-chevron-circle-left"}/>
                            </NavLink>
                        </NavBar>
                    </div>
                    <div className="table-responsive">
                        <Container
                            title={dropbox.name + ': ' + assignment.name}
                            className="submission-form"
                        >
                            <CardBlock>
                                <CardHeader className="bg-primary">Files for {user.first_name} {user.last_name} ({user.username})</CardHeader>
                                {
                                    this.hasRequiredFiles(assignment)
                                    ? (
                                        <FileSubmission
                                            downloadOnly={true}
                                            onDropFixedFilename={()=>{}}
                                            onDropAdditionalFile={()=>{}}
                                            display={'required'}
                                            label={
                                                'Required Files (Fixed name files ' +
                                                'marked as required by Instructor)'
                                            }
                                            uploadAllowed={false}
                                            submission={submission}
                                            assignment={assignment}
                                            onDownloadFile={this.onDownloadFile}
                                            onRemoveFile={()=>{}}
                                        />
                                    ) : null
                                }
                                {
                                    this.hasOptionalFiles(assignment)
                                    ? (
                                        <FileSubmission
                                            downloadOnly={true}
                                            onDropFixedFilename={()=>{}}
                                            onDropAdditionalFile={()=>{}}
                                            display={'optional'}
                                            label={
                                                'Optional Files (Fixed name files ' +
                                                'marked as optional by Instructor)'
                                            }
                                            uploadAllowed={false}
                                            submission={submission}
                                            assignment={assignment}
                                            onDownloadFile={this.onDownloadFile}
                                            onRemoveFile={()=>{}}
                                        />
                                    ) : null
                                }
                                {
                                    assignment.allow_arbitrary_uploads
                                    ? (
                                        <FileSubmission
                                            downloadOnly={true}
                                            onDropFixedFilename={()=>{}}
                                            onDropAdditionalFile={()=>{}}
                                            display={'additional'}
                                            label={
                                                this.hasOptionalFiles(assignment) ||
                                                this.hasRequiredFiles(assignment)
                                                    ? 'Additional Files'
                                                    : 'Files'
                                            }
                                            uploadAllowed={false}
                                            submission={submission}
                                            assignment={assignment}
                                            onDownloadFile={this.onDownloadFile}
                                            onRemoveFile={()=>{}}
                                        />
                                    ) : null
                                }
                                <div className="check-submitted">
                                    <label className="help-text">
                                        Checked submission {submission.attempts}
                                        &nbsp;out of&nbsp;
                                        {
                                            assignment.submission_attempts_max > 0 ?
                                                assignment.submission_attempts_max :
                                                "unlimited"
                                        } times
                                    </label>
                                    <button
                                        className="btn btn-link download-file pointer bottom right"
                                        onClick={this.handleLatestRunscripts}
                                        disabled={submission.attempts < 1}
                                        title={"Latest Check Submitted Files"}
                                    >
                                        Latest Check Submitted Files
                                    </button>
                                </div>
                            </CardBlock>
                        </Container>
                    </div>
                </div>
            );
        }
        return null;
    }
}

SubmittedPage.propTypes = {
    dispatch: PropTypes.func.isRequired,
    params: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    const { assignments, auth, dropboxes, memberships, request, roles_self, submissions, users } = state;

    return { assignments, auth, dropboxes, memberships, request, roles_self, submissions, users };
}

export default connect(mapStateToProps)(withRouter(SubmittedPage));



/** WEBPACK FOOTER **
 ** ./src/containers/SubmittedPage.js
 **/